import { apiClient } from "./apiClient";
import UserProfile from "../types/UserProfile";

export const getProfile = async (): Promise<UserProfile> => {
  let url_prefix = "https://roger-that-e17b66fe09c9.herokuapp.com/";
  if (process.env.NODE_ENV === "development") {
    url_prefix = "http://127.0.0.1:8000/";
  }
  var url = url_prefix + "apiapp/users/me/";
  var responseData = await apiClient(url, null, "GET");

  return {
    id: responseData.id,
    firstName: responseData.first_name || "",
    lastName: responseData.last_name || "",
    dateOfBirth: responseData.date_of_birth || "",
    email: responseData.email || "",
    phoneNumber: responseData.phone_number || "",
    username: responseData.username || "",
    userType: responseData.user_type || "",
    otherSoftware: responseData.other_software || "",
    experience: responseData.experience || "",
    feedback: responseData.feedback || "",
    reminderEmail: responseData.reminder_email,
    reminderBrowser: responseData.reminder_browser,
    highScore: responseData.high_score,
    completedSurvey: responseData.completed_survey,
    practiceCount: responseData.practice_count,
  };
};
